import React from 'react';
import Svg, { Path } from 'react-native-svg';

export interface GlobeMarkerProps {
  size?: number;
  primaryFill: string;
  secondaryFill: string;
}

function GlobeMarker({
  size = 121,
  primaryFill,
  secondaryFill,
}: GlobeMarkerProps): JSX.Element {
  return (
    <Svg
      width={size}
      height={(size * 120) / 121}
      viewBox="0 0 121 120"
      fill="none"
    >
      <Path
        d="M110.5 60C110.5 87.6142 88.1142 110 60.5 110
           M110.5 60C110.5 32.3858 88.1142 10 60.5 10
           M110.5 60H10.5
           M60.5 110C32.8858 110 10.5 87.6142 10.5 60
           M60.5 110C73.0064 96.3082 80.1138 78.5398 80.5 60
           C80.1138 41.4602 73.0064 23.6918 60.5 10
           M60.5 110C47.9936 96.3082 40.8862 78.5398 40.5 60
           C40.8862 41.4602 47.9936 23.6918 60.5 10
           M10.5 60C10.5 32.3858 32.8858 10 60.5 10"
        stroke={primaryFill}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default GlobeMarker;